var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppAccordion',_vm._l((_vm.items),function(item,index){return _c('AppAccordionItem',{key:index,attrs:{"title":item.question,"prefix":`faq-${index}`,"data-e2e":"faqQuestion"}},[_c('ContentCard',[_c('ContentCardText',[_c('span',{domProps:{"innerHTML":_vm._s(item.answer)}})])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }